var map = {
	"./amboss_px.png": "0015",
	"./arrow.gif": "3bc4",
	"./arschkarte_px.png": "5048",
	"./axt_px.png": "2f6b",
	"./dolmar_px.png": "be42",
	"./efdab_px.png": "3ddb",
	"./flask.png": "acf2",
	"./katana_px.png": "b527",
	"./landkarte_px.png": "f550",
	"./manabar_px.png": "998b",
	"./messer_px.png": "f21c",
	"./opfer_tatort_px.png": "ba66",
	"./polaroid_px.png": "7f63",
	"./schlaeger_px.png": "741b",
	"./schlauch_comb_px.png": "2af9",
	"./schlauch_px.png": "07b7",
	"./schluessel_px.png": "ac1c",
	"./speisekarte_px.png": "134c",
	"./taucherbrille_px.png": "aa87",
	"./toefflibueb_px.png": "268a",
	"./tuerklinke_px.png": "109f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b2b";